<template>
  <div>
    <v-overlay :value="loading" :absolute="true">
      <v-progress-circular indeterminate></v-progress-circular>
    </v-overlay>
    <DriversLoadsReportTemplate v-if="$route.name === 'reportPrint'"
                         :entries="loads"
                         :totalsCounts="totalsCounts"
                         :from="from"
                         :to="to"
                         :driverName="driverName"
                         :driverSoloRate="driverSoloRate"
                         :driverTeamRate="driverTeamRate"
                         :key="'reportTemplateKey' + loads.length"/>
    <v-card v-else>
      <v-card-title>{{driverName}}<!--<v-spacer/><v-btn small @click="$emit('back-to-list')"><v-icon left small>mdi-view-list</v-icon> {{$t('BackDriversToList')}}</v-btn>--></v-card-title>
      <v-layout v-if="driverId > 0">
        <v-flex xs12>
          <v-card class="ma-2">
            <ReportsGroupsList
              :type="$route.params.type"
              :userId="driverId"
              :totalsCountsNames="totalsCountsNames"
              :totalsCounts="totalsCounts"
              :key="reportsGroupsListKey"/>
          </v-card>
        </v-flex>
      </v-layout>

      <!--<v-tabs :value="1" grow class="mt-2" show-arrows active-class="tabs-active-color">
        <v-tab @click="$root.route('/reports/drivers' + ($route.params.item ? '/' + $route.params.item : ''))"><v-icon left>mdi-map-marker-path</v-icon>{{$t('Reports.DriverShifts')}}</v-tab>
        <v-tab @click="$root.route('/reports/driversLoads' + ($route.params.item ? '/' + $route.params.item : ''))"><v-icon left>mdi-dolly</v-icon>{{$t('Reports.DriverLoads')}}</v-tab>
      </v-tabs>-->

      <v-card-title>
        <h2>Driver Loads</h2>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <v-layout wrap>
        <v-flex xs12 md6>
          <DriverTotals :from="from"
                        :to="to"
                        :key="from+to"
                        :driverId="$route.params.item"/>
        </v-flex>
      </v-layout>

      <!--<v-layout v-if="$root.isFullFinancialDataAllowedToView && driverId > 0">
        <v-flex xs12 class="text-right">
          <ReportActions
          :selectedItems="selectedItems"
          :lastReportsGroupNumber="lastReportsGroupNumber"
          :userId="driverId"
          :type="$route.params.type"
          :from="from"
          :to="to"
          :isSelectedHaveNotPayed="isSelectedHaveNotPayed"
          :isSelectedHavePayed="isSelectedHavePayed"
          @paidDTChangeMulti="$emit('paidDTChangeMulti', selectedItems, driverId, selectedItems[0].payedDateTime)"
          @markSelectedAsPayedAndCreateReportGroup="markSelectedAsPayedAndCreateReportGroup"
          @markSelectedAsPayed="markSelectedAsPayed"
          @markSelectedAsNotPayed="markSelectedAsNotPayed"
          @createReportGroup="createReportGroup"
          />
        </v-flex>
      </v-layout>-->

      <!--<hr/>
      {{loads}}
      <hr/>-->
      <v-data-table
        :headers="headers"
        :items="loads"
        :search="search"
        :items-per-page="100"
        :footer-props="footer_props"
        v-model="selectedItems"
        height="calc(100vh - 200px)"
        fixed-header
        show-select
        @item-selected="onItemSelected"
        @toggle-select-all="onItemSelected"
        @click:row="$root.onShowLoadPreview($event.id)"
      >
        <template v-slot:item.status="{ item }">
          <div class="text-no-wrap">
            <v-icon v-if="item.status.phaseIcon" v-html="item.status.phaseIcon" :color="item.status.phaseColor" class="mr-1"></v-icon>
            <v-icon v-if="item.status.stageIcon" small v-html="item.status.stageIcon" :color="item.status.stageColor" class="mr-1"></v-icon>
            <v-icon v-if="item.isReturnToHQ === 1" color="success" class="mr-1">mdi-redo-variant</v-icon>
          </div>
        </template>

        <template v-slot:item.started="{ item }">
          <div class="text-no-wrap">{{item.startedPST}}</div>
          <div class="text-no-wrap">{{item.endedPST}}</div>
        </template>

        <template v-slot:item.uid_load_number="{ item }">
          <span class="text-no-wrap">
            {{item.loadNumber}}
            <v-btn v-if="item.loadNumber" small icon @click.stop="$root.copyToClipboard(item.loadNumber)"><v-icon small>mdi-content-copy</v-icon></v-btn>
          </span>
          <br/>
          <span class="text-no-wrap">
            {{item.uid}}
            <v-btn v-if="item.uid" small icon @click.stop="$root.copyToClipboard(item.uid)"><v-icon small>mdi-content-copy</v-icon></v-btn>
          </span>
        </template>

        <template v-slot:item.miles="{ item }">
          <v-tooltip bottom v-if="isMapsOdometerTreshholdReached(item.milesByMaps, item.milesByOdometer)">
            <template v-slot:activator="{ on }">
              <v-chip v-on="on" small color="warning">
                <v-icon left small>mdi-alert</v-icon>
                {{item.milesByMaps.toLocaleString()}}&nbsp;/&nbsp;{{item.milesByOdometer.toLocaleString()}} {{$t('milesShort')}}
              </v-chip>
            </template>
            <span v-if="item.milesByMaps > item.milesByOdometer">{{$tc('Reports.MilesByMapsMoreThenByOdometer', item.milesByMaps - item.milesByOdometer)}}</span>
            <span v-if="item.milesByMaps < item.milesByOdometer">{{$tc('Reports.MilesByOdometerMoreThenByMaps', item.milesByOdometer - item.milesByMaps)}}</span>
          </v-tooltip>
          <span v-else>
            {{item.milesByMaps.toLocaleString()}}&nbsp;/&nbsp;{{item.milesByOdometer.toLocaleString()}} {{$t('milesShort')}}
          </span>
        </template>

        <template v-slot:item.rate="{ item }">
          <v-chip v-if="item.isPaid" class="ma-1" label small color="success">
            {{$t('Reports.Paid')}}
            <div class="text-no-wrap">&nbsp;${{item.rateByMaps.toLocaleString()}}&nbsp;/&nbsp;{{item.rateByOdometer.toLocaleString()}}</div>
          </v-chip>
          <span v-else class="text-no-wrap">
            <v-icon small class="mr-1">fa-dollar-sign</v-icon>{{item.rateByMaps.toLocaleString()}}&nbsp;/&nbsp;{{item.rateByOdometer.toLocaleString()}}
            <v-tooltip bottom v-if="item.isDriverAssist">
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="warning" :size="32">$vuetify.icons.driverAssist</v-icon>
              </template>
              <span>{{$t('Loads.isDriverAssist')}}</span>
            </v-tooltip>
          </span>
          <br v-if="item.isPaid">
          <div class="text-no-wrap" v-if="item.isPaid">
            <label class="caption text-no-wrap">{{item.payedDateTime}}</label>
            <v-btn icon small @click.stop="$emit('paidDTChanged', item.id, driverId, item.payedDateTime)"><v-icon small>mdi-pencil</v-icon></v-btn>
          </div>
<!--          <template v-if="item.finished === 2"><v-chip color="warning" small>TONU</v-chip></template>-->
          <!--<div class="text-no-wrap"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{item.rateByMaps.toLocaleString()}}&nbsp;/&nbsp;{{item.rateByOdometer.toLocaleString()}}</div>-->
        </template>

        <template v-slot:item.drivers_trucks="{ item }">
          <TruckDriversSnippet :trucks="item.trucks" :isDriverOO="item.isDriverOwnerOperator === 1" :truckOO="item.truckOOData" :driverOO="item.driverOOData" :load-id="item.id"></TruckDriversSnippet>
        </template>

        <template v-slot:item.name="{ item }">
          <!--<template v-if="driverId">
            <template v-for="locationEntry in item.locations">
              <v-icon small class="mr-2" :color="$root.getLocationColor(locationEntry)">{{$root.getLocationIcon(locationEntry)}}</v-icon>{{locationEntry.name}}<br/>
            </template>
          </template>
          <template v-else>
            {{item.name.split('--')[0]}}
            <br/>
            {{item.name.split('--')[1]}}
          </template>-->
          <v-layout >
            <v-flex shrink>
              <LoadLocationsTooltip :load-fields="item"></LoadLocationsTooltip>
            </v-flex>
            <v-flex class="text-left">
              <LoadLocationsStartEnd
                :load-name="item.name"
                :max-width="'200px'"
                :gmapsDirectionsBtn="true"
                @open-gmaps-directions="() => { $root.openGmapsDirections(item) }"
                @show-map-modal="() => { $emit('show-map-modal', item) }"
                @show-map-div="(event) => { $emit('show-map-modal', item, true, event) }"
              />
            </v-flex>
          </v-layout>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-layout>
            <v-flex class="pa-0" v-for="invoiceItem in item.invoicesArray" :key="'inv'+invoiceItem.id">
              <template v-if="invoiceItem.invoiceReceivedDate > 0 && $root.isInvoicesViewAllowed">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" :color="$root.getInvoiceTypeColorByStatus(invoiceItem.invoiceStatus)" @click.stop="$root.route('/invoices/page/'+invoiceItem.invoiceId)"><v-icon small>fa-file-invoice-dollar</v-icon></v-btn>
                  </template>
                  <span>{{$t('Loads.Invoice')}} #{{invoiceItem.invoiceNumber}} ${{invoiceItem.invoiceTotal}}&nbsp;<strong>{{invoiceItem.invoiceStatus}}</strong></span>
                </v-tooltip>
              </template>
              <template v-else-if="!invoiceItem.invoiceReceivedDate && $root.isInvoicesViewAllowed">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" :color="invoiceItem.invoiceDueLeftSeconds < 0 ? 'red' : 'warning'" @click.stop="$root.route('/invoices/page/'+invoiceItem.invoiceId)"><v-icon small>fa-file-invoice-dollar</v-icon></v-btn>
                  </template>
                  <span v-if="invoiceItem.invoiceDueLeftSeconds < 0">{{$t('Loads.Invoice')}} #{{invoiceItem.invoiceNumber}} ${{invoiceItem.invoiceTotal}}&nbsp;{{$t('Invoices.Overdue')}}:&nbsp;-{{Math.ceil($root.secondsToHms(invoiceItem.invoiceDueLeftSeconds).hours / 24)}} d.</span>
                  <span v-if="invoiceItem.invoiceDueLeftSeconds > 0">{{$t('Loads.Invoice')}} #{{invoiceItem.invoiceNumber}} ${{invoiceItem.invoiceTotal}}&nbsp;{{$t('Invoices.DueDate')}}:&nbsp;+{{Math.ceil($root.secondsToHms(invoiceItem.invoiceDueLeftSeconds).hours / 24)}} d.</span>
                </v-tooltip>
              </template>
            </v-flex>
            <v-flex v-if="item.invoicesArray.length === 0">
              <v-btn icon disabled><v-icon small class="mr-1">fa-file-invoice-dollar</v-icon></v-btn>
            </v-flex>
            <v-flex>
              <template v-if="item.bid">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" @click.stop="$root.route('/bids/'+item.bid)"><v-icon small class="mr-1">mdi-file-question</v-icon></v-btn>
                  </template>
                  <span>Bid #{{item.bid}}</span>
                </v-tooltip>
              </template>
            </v-flex>
            <v-flex>
              <template>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" @click.stop="onShowDocuments(item)"><v-icon small class="mr-1">mdi-file-multiple</v-icon></v-btn>
                  </template>
                  <span>{{$t('Loads.uploadDocuments')}}</span>
                </v-tooltip>
              </template>
            </v-flex>
            <v-flex>
              <template>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" @click.stop="onShowExpenses(item.expensesJSON, item.finished, item.id)">
                      <v-icon small class="mr-1" :color="item.isPendingExpenses ? 'warning' : 'success'">fa-coins</v-icon>
                    </v-btn>
                  </template>
                  <span>{{!item.isPendingExpenses ? $t('Loads.ExpensesTitle') : $t('Loads.ExpensesHasPending')}}</span>
                </v-tooltip>
              </template>
            </v-flex>
          </v-layout>
        </template>

      </v-data-table>

      <!--<v-layout v-if="$root.isFullFinancialDataAllowedToView && driverId > 0">
        <v-flex xs12 class="text-right">
          <ReportActions
            :selectedItems="selectedItems"
            :lastReportsGroupNumber="lastReportsGroupNumber"
            :userId="driverId"
            :type="$route.params.type"
            :from="from"
            :to="to"
            :isSelectedHaveNotPayed="isSelectedHaveNotPayed"
            :isSelectedHavePayed="isSelectedHavePayed"
            @paidDTChangeMulti="$emit('paidDTChangeMulti', selectedItems, driverId, selectedItems[0].payedDateTime)"
            @markSelectedAsPayedAndCreateReportGroup="markSelectedAsPayedAndCreateReportGroup"
            @markSelectedAsPayed="markSelectedAsPayed"
            @markSelectedAsNotPayed="markSelectedAsNotPayed"
            @createReportGroup="createReportGroup"
          />
        </v-flex>
      </v-layout>-->

      <v-dialog v-model="expensesModal" scrollable max-width="1000px">
        <v-card>
          <v-card-title>
            <h2>{{$t('Loads.ExpensesTitle')}}</h2><v-spacer></v-spacer><v-btn icon @click="expensesModal=false;"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <LoadExpenses :key="expensesModalKey"
                        :expensesArray="selectedExpenses"
                        :readOnly="!$root.isLoadsEditAllowed"
                        :isFinished="selectedFinishedField !== 0"
                        :loadId="selectedExpensesLoadId"
                        @expensesSaved="fetchData()"
          ></LoadExpenses>
        </v-card>
      </v-dialog>
      <v-dialog v-model="documentsModal" scrollable>
        <v-card>
          <v-card-title>
            <h2>{{$t('Loads.uploadDocuments')}}</h2><v-spacer></v-spacer><v-btn icon @click="documentsModal=false;"><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <LoadDocuments :key="documentsModalKey" :fields="selectedELoadFields" :readonly="true"></LoadDocuments>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import reportsMixin from '../../mixins/reportsMixin.js';
import LoadExpenses from '../../components/LoadExpenses.vue';
import LoadDocuments from '../../components/LoadDocuments.vue';
import DriversLoadsReportTemplate from './DriversLoadsReportTemplate.vue';
import ReportsGroupsList from './ReportsGroupsList.vue';
import LoadLocationsTooltip from '../../components/LoadLocationsTooltip.vue';
import TruckDriversSnippet from '../../components/TruckDriversSnippet';
import ReportActions from '../../components/ReportActions.vue';
import DriverTotals from './DriverTotals';
import LoadLocationsStartEnd from '../../components/LoadLocationsStartEnd';

export default {
  name: 'DriverLoadsReport',
  props: ['from', 'to', 'driverId', 'driverName', 'selected', 'driverSoloRate', 'driverTeamRate'],
  components: {LoadLocationsStartEnd, TruckDriversSnippet, LoadLocationsTooltip, LoadExpenses, LoadDocuments, DriversLoadsReportTemplate, ReportsGroupsList, ReportActions, DriverTotals },
  mixins: [reportsMixin],
  data: function () {
    return {
      loading: false,
      totalsCounts: {
        loads: 0,
        totalMilesByMap: 0,
        totalMilesByOdometer: 0,
        totalRateByMap: 0,
        totalRateByOdometer: 0
      },
      totalsCountsNames: {
        loads: 'Loads',
        totalMilesByMap: 'Total Miles By Map',
        totalMilesByOdometer: 'Total Miles By Odometer',
        totalRateByMap: 'Total Rate By Map',
        totalRateByOdometer: 'Total Rate By Odometer'
      },
      loads: [],
      selectedItems: [],
      search: '',
      expensesModal: false,
      expensesModalKey: new Date().getTime(),
      selectedExpenses: [],
      selectedExpensesLoadId: 0,
      selectedFinishedField: 0,
      documentsModal: false,
      documentsModalKey: new Date().getTime(),
      selectedELoadFields: {},
      milesDiffHighlightThreshold: 30,
      headers: [
        { text: '#', value: 'id' },
        { text: '', value: 'status' },
        { text: 'Started / Ended', value: 'started' },
        { text: 'Locations', value: 'name' },
        { text: 'Drivers / Trucks', value: 'drivers_trucks', sortable: false },
        { text: 'UID / Load Number', value: 'uid_load_number', sortable: false },
        { text: 'Miles by Maps / Odometer', value: 'miles' },
        { text: 'Rate by Maps / Odometer', value: 'rate' },
        { text: '', value: 'actions', sortable: false }
      ],
      footer_props: {
        'items-per-page-options': [10, 25, 50, 100],
        'items-per-page-text': '',
        'disable-items-per-page': false
      }
    };
  },
  computed: {
  },
  mounted () {
    this.$root.setLastListPath(this.$route.path);
    this.$root.getGlobalSettingsField('milesDiffHighlightThreshold').then((response) => {
      if (response.status === 'ok') {
        this.milesDiffHighlightThreshold = parseInt(response.result);
      }
    });
    this.$nextTick(() => {
      this.fetchData().then(() => {
        //this.updateLastReportsGroupNumber(this.driverId, this.$route.params.type);
      });
    });
  },
  methods: {
    clearTotals () {
      this.totalsCounts = {
        loads: 0,
        totalMilesByMap: 0,
        totalMilesByOdometer: 0,
        totalRateByMap: 0,
        totalRateByOdometer: 0
      };
    },
    isMapsOdometerTreshholdReached (mapsMiles, odometerMiles) {
      return Math.abs(mapsMiles - odometerMiles) > this.milesDiffHighlightThreshold;
    },
    onItemSelected () {
      this.$nextTick(() => {
        let selected = [];
        for (let i = 0; i < this.selectedItems.length; i++) {
          selected.push(parseInt(this.selectedItems[i]['id']));
        }
        this.$emit('selected', selected);
      });
    },
    onShowExpenses (expensesJSON, finishedField, loadId) {
      if (expensesJSON) {
        this.selectedExpensesLoadId = loadId;
        this.selectedExpenses = JSON.parse(expensesJSON);
        this.selectedFinishedField = finishedField;
        this.expensesModalKey = new Date().getTime();
        this.expensesModal = true;
      }
    },
    onShowDocuments (fields) {
      if (fields) {
        this.selectedELoadFields = fields;
        this.documentsModalKey = new Date().getTime();
        this.documentsModal = true;
      }
    },
    fetchData (skipSelected = false, selected = []) {
      return new Promise((resolve, reject) => {
        let i = 0;
        let l = 0;
        this.loading = true;
        this.getLoadsReportData(this.from, this.to, 0, this.driverId).then((response) => {
          if (response.status === 'ok') {
            this.clearTotals();
            this.loads = [];

            let selectedArray = [];
            if (this.selected && !skipSelected) {
              selectedArray = this.selected.split(',').map(v => {
                return parseInt(v);
              });
            }
            if (selected.length > 0) {
              selectedArray = selected;
            }

            this.selectedItems = [];
            for (i = 0; i < response.loads.length; i++) {
              let load = response.loads[i];
              if (selectedArray.length > 0 && selectedArray.indexOf(parseInt(load.id)) < 0) continue;

              this.totalsCounts.miles += parseInt(response.loads[i].distanceInMiles);
              this.totalsCounts.totalRate += parseFloat(response.loads[i].Rate);

              // const locations = JSON.parse(response.loads[i].locationsJSON.replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t'));
              const locations = response.loads[i].locations;
              load.status = this.$root.getLoadStatus(locations, response.loads[i].finished);
              let pickupLocationName = '';
              let deliveryLocationName = '';

              for (l = 0; l < locations.length; l++) {
                if (locations[l].pickup) {
                  pickupLocationName = locations[l].name;
                  break;
                }
              }

              for (l = locations.length - 1; l >= 0; l--) {
                if (locations[l].delivery) {
                  deliveryLocationName = locations[l].name;
                  break;
                }
              }
              // Process load item
              load.rateByMaps = 0;
              load.rateByOdometer = 0;
              load.milesByMaps = 0;
              load.milesByOdometer = 0;

              if (load.hasOwnProperty('expensesByMaps') && load.expensesByMaps.driverRates.hasOwnProperty(this.driverId)) {
                load.rateByMaps = parseFloat(load.expensesByMaps.driverRates[this.driverId]);
              } else if (this.driverId === 0) {
                for (let d in load.expensesByMaps.driverRates) {
                  if (load.expensesByMaps.driverRates.hasOwnProperty(d)) {
                    load.rateByMaps += parseFloat(load.expensesByMaps.driverRates[d]);
                  }
                }
              }

              if (load.hasOwnProperty('expensesByOdometer') && load.expensesByOdometer.driverRates.hasOwnProperty(this.driverId)) {
                load.rateByOdometer = parseFloat(load.expensesByOdometer.driverRates[this.driverId]);
              } else if (this.driverId === 0) {
                for (let d in load.expensesByOdometer.driverRates) {
                  if (load.expensesByOdometer.driverRates.hasOwnProperty(d)) {
                    load.rateByOdometer += parseFloat(load.expensesByOdometer.driverRates[d]);
                  }
                }
              }

              load.locations = [];
              for (l = 1; l < locations.length; l++) {
                const prevLocation = locations[l - 1];
                const location = locations[l];
                const distance = this.$root.metersToMiles(location.distance);

                if (prevLocation.driver !== parseInt(this.driverId) && prevLocation.codriver !== parseInt(this.driverId)) {
                  if (load.locations.length === 0) {
                    continue;
                  } else {
                    break;
                  }
                }

                if (load.locations.length === 0) {
                  load.locations.push(prevLocation);
                }

                load.milesByMaps += parseInt(distance);
                if (location.odometerStart && location.odometer) {
                  load.milesByOdometer += parseInt(location.odometer) - parseInt(location.odometerStart);
                }

                if (pickupLocationName === '') {
                  pickupLocationName = prevLocation.name;
                }
                deliveryLocationName = location.name;

                load.locations.push(location);
/*
                // Fill last locations if needed
                if (l === locations.length - 1) {
                  if (!driverCnaged) {
                    load.locations.push(location);
                  }
                  break;
                }

                const nextLocation = locations[l + 1];
                const distance = this.$root.metersToMiles(location.distance);

                if (parseInt(location.driver) === parseInt(this.driverId) || parseInt(location.codriver) === parseInt(this.driverId)) {
                  load.locations.push(location);
                  driverCnaged = false;
                } else if (!driverCnaged) {
                  load.locations.push(location);
                  driverCnaged = true;
                }

                if (pickupLocationName === '' &&
                                    ((location.driver && parseInt(location.driver) === this.driverId) ||
                                    (location.codriver && parseInt(location.codriver) === this.driverId))) {
                  pickupLocationName = location.name;
                }

                if ((location.driver && parseInt(location.driver) === this.driverId) || (location.codriver && parseInt(location.codriver) === this.driverId)) {
                  deliveryLocationName = nextLocation.name;
                }

                let odometerDistance = 0;
                if (nextLocation.odometerStart && nextLocation.odometer) {
                  odometerDistance = parseInt(nextLocation.odometer) - parseInt(nextLocation.odometerStart);
                }

                load.milesByMaps += parseInt(distance);
                load.milesByOdometer += parseInt(odometerDistance);
*/

                /*if (!this.driverId || this.driverId === 0 ||
                    ((location.driver > 0 && parseInt(location.driver) === parseInt(this.driverId)) ||
                    (location.codriver > 0 && parseInt(location.codriver) === this.driverId))) {
                  /!* if (location.driverRate) {
                                        this.loads[i].rateByMaps += parseFloat(distance) * parseFloat(location.driverRate);
                                        this.loads[i].rateByOdometer += parseFloat(odometerDistance) * parseFloat(location.driverRate);
                                    } *!/
                  // console.log(load.id, distance);
                }*/
              }

              if (!this.driverId) {
                load.locations = locations;
              }

              load.uid_load_number = load.loadNumber + ' ' + load.uid;

              pickupLocationName = pickupLocationName.replace(/, USA/gi, '');
              if (pickupLocationName.split(',').length > 2) {
                pickupLocationName = pickupLocationName.substring(pickupLocationName.indexOf(',') + 1);
              }
              deliveryLocationName = deliveryLocationName.replace(/, USA/gi, '');
              if (deliveryLocationName.split(',').length > 2) {
                deliveryLocationName = deliveryLocationName.substring(deliveryLocationName.indexOf(',') + 1);
              }

              load.name = pickupLocationName + ' -- ' + deliveryLocationName;

              load.isPaid = false;
              // Extract status
              if (load.reportsStatuses && load.reportsStatuses.indexOf('{') === 0) {
                const reportsStatusesObject = JSON.parse(load.reportsStatuses);
                load.isPaid = reportsStatusesObject.hasOwnProperty(this.driverId + '_payed');
                load.payedDateTime = reportsStatusesObject[this.driverId + '_payed'];
              }
              /* if (load.isPaid) {
                                if (response.loads[i].driverSalary > 0) {
                                    this.totalsCounts.totalPaidSalary += parseFloat(response.loads[i].driverSalary);
                                }
                            } */

              this.totalsCounts.totalMilesByMap += parseInt(load.milesByMaps);
              this.totalsCounts.totalMilesByOdometer += parseInt(load.milesByOdometer);
              this.totalsCounts.totalRateByMap += parseFloat(parseFloat(load.rateByMaps).toFixed(2));
              this.totalsCounts.totalRateByOdometer += parseFloat(parseFloat(load.rateByOdometer).toFixed(2));
              this.loads.push(load);
            }


            this.totalsCounts.loads = this.loads.length;
          }
          this.onItemSelected();
          this.$forceUpdate();
          this.loading = false;
          resolve(this.totalsCounts);
        });
      });
    }
  }
};
</script>
